export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const titles = ["Mr.", "Mrs.", "Ms.", "Miss.", "Mx.", "Dr.", "Prof.", "Rev."]


export const STEP_NAMES = [
  'VehicleIdentification',
  'EmailAndAgreement',
  'VehiclesSelection',
  'VehicleAcquisitionDates',
  'AddressesSelection',
  'ContactForm',
  'FeeCap',
  'SignaturePad',
  'CreditReportAuthentication',
  'CreditReport'
] as const;


export const faqQuestions = [
  {
    label: 'What types of car claims do you handle?',
    content: 'We currently handle claims related to mis-sold PCP (Personal Contract Purchase) car finance agreements and Jaguar Land Rover Diesel Particulate Filter (DPF) issues. If you think you may have been affected, we can help you check quickly and easily.'
  },
  {
    label: 'How long does the claims process take?',
    content: 'The timeline can vary depending on the type of claim, the complexity of your case, and the response times of the other parties involved. While some claims may be resolved in a few months, others can take longer. We will keep you informed every step of the way.'
  },
  {
    label: 'Why hire a solicitor to make a claim?',
    content: 'The legal claims world is complicated, and having a team of solicitors and agents in your corner allows for us to do the heavy lifting for you. Once you submit a claim, Johnson Law Group will review your facts, and an experienced legal team specialising in car claims will manage the process on your behalf.'
  },
  {
    label: 'How much does it cost?',
    content: `There’s no cost to check if you’re eligible, and we work on a <strong>no win, no fee</strong> basis. That means you only pay if your claim is successful.`
  },
  {
    label: 'How do I get started?',
    content: 'Simply enter your vehicle registration mark (VRM) and answer a few quick questions on our website. We’ll check if you may have a claim or multiple claims and guide you through the next steps.'
  },
]

export const faqFCA = [
  {
    label: 'What does this mean for me?',
    content: 'If you wish to do the work of identifying and claiming against your finance companies yourself from 2007 onwards, you can do so, free of charge.'
  },
  {
    label: 'Why use <a class="hover:underline" href="https://claimsforcars.com/">ClaimsForCars.com</a>?',
    content: 'Regulated by the Solicitors Regulation Authority, we work on a no-win, no-fee agreement for you, protected by the <a class="text-(--brand-primary) hover:underline" href="https://www.sra.org.uk/solicitors/standards-regulations/claims-management-fees-rules/">SRA fee cap</a>. We handle the work for you, and we are incentivised to get you the biggest award possible as we take up to 30% of your total damages only after YOU win. We\'ll continue to fight for you, even when the banks argue you shouldn\'t get compensation.'
  },
  {
    label: 'What are my rights of termination?',
    content: 'Your retainer with us offers a 14-day cooling off period in case you wish to change your mind -- without charge! If you cancel after the 14-day period, we retain the right to charge costs for the work we have done on your file, up to a maximum of £150 + VAT.'
  },
  {
    label: 'What should I expect to get?',
    content: `The FCA has advised that successful claimants can expect to receive up to £700 per agreement through a redress scheme the FCA plans to launch. The <a class="text-(--brand-primary) hover:underline" href="https://www.fca.org.uk/news/statements/fca-consults-motor-finance-compensation-scheme" target="_blank">FCA</a> has stated it expects 44% of agreements from 2007-2021 may be successful under its scheme. (FCA, 7 October 2025).`
  },
  {
    label: 'What could I owe?',
    content: 'If we pursue a claim for you under the FCA scheme you will only owe us our fee in the event you are successful.<br/>If we issue proceedings in court on your behalf, then you may be responsible for your opponents costs if you lose. However we will always ensure you are fully indemnified against such costs which means that if you lose your claim in court you will not be out of pocket (provided of course you have told the truth and not withdrawn your instructions part way through the claim).<br/>The cost of insurance to protect you against your opponents costs (Legal Expense Insurance) varies but we anticipate that it will be approximately £100 - which you will pay out of your compensation if you win. If you lose the policy of insurance will pay for its own premium in addition to any other legal costs. So you will never be out of pocket in those circumstances.'
  }
]

export const UK = 'gb'
export const US = 'us'
export const countryCodes = {
  [UK]: '+44',
  [US]: '+1'
}
export const countries = Object.keys(countryCodes)
export const defaultCountry = UK
